import styled from 'styled-components';
import { Text } from '@rsos/components/capstone/base';

interface RadioButtonTitleProps {
  hasError?: boolean;
}

export const RadioButtonTitle = styled(Text).attrs({})<RadioButtonTitleProps>`
  color: ${p =>
    p.hasError ? p.theme.colors.lightDanger : p.theme.colors.primaryText};
`;
